export enum TipoDocumentoLicitaconTipoEnum {
  LICITACAO = 'LICITACAO',
  CONTRATO = 'CONTRATO'
}

export const tipoDocumentoLicitaconEnum = {
  OUT: 'Outros Documentos',
  ART: 'Anotação de Responsabilidade Técnica/Registro de Responsabilidade Técnica',
  DGC: 'Documento de Garantia Contratual',
  RIM: 'Registro de Imóvel',
  PNM: 'Planilha de Medição',
  RLM: 'Relatório de Medição',
  RFT: 'Relatório Fotográfico',
  DCC: 'Documento Convênio/Contrato de Financiamento',
  TAD: 'Termo Aditivo',
  APO: 'Apostilamento'
};
